import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';

// Suppress React Router v7 warnings
if (typeof window !== 'undefined') {
  window.__REACT_ROUTER_V7_START_TRANSITION__ = true;
  window.__REACT_ROUTER_V7_RELATIVE_SPLAT_PATH__ = true;
}

import setupLocatorUI from "@locator/runtime";

if (process.env.NODE_ENV === "development") {
  setupLocatorUI();
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <App />
);
